// Obchodní podmínky Analytical Platform (CS)
// Generated from the source Word document - keep the wording verbatim.
import type { LegalDocument } from "./types";

const termsCs: LegalDocument = {
  "title": "Obchodní podmínky Analytical Platform",
  "effectiveFrom": "Účinné od 18. 09. 2026",
  "sections": [
    {
      "heading": "1. Úvodní ustanovení",
      "blocks": [
        {
          "kind": "clause",
          "number": "1.1.",
          "text": "Tyto obchodní podmínky (dále jen „Podmínky“) upravují používání technologické platformy Analytical Platform, jednotlivých aplikací, produktů, nástrojů a funkcionalit poskytovaných jejím prostřednictvím a souvisejících služeb (dále společně jen „Služba“)."
        },
        {
          "kind": "clause",
          "number": "1.2.",
          "text": "Provozovatelem Analytical Platform je CCFR, sdružení společností CCF RESEARCH, a.s. a CCFR SOFTWARE, s.r.o. (dále jen „Provozovatel“)."
        },
        {
          "kind": "clause",
          "number": "1.3.",
          "text": "Analytical Platform představuje technologické prostředí, jehož prostřednictvím Provozovatel zpřístupňuje Uživateli jednotlivé analytické aplikace, produkty, nástroje a související funkcionality."
        },
        {
          "kind": "clause",
          "number": "1.4.",
          "text": "Jednotlivé aplikace nebo produkty mohou být prezentovány také prostřednictvím samostatných webových stránek. Jejich funkcionality mohou být poskytovány prostřednictvím společného technologického prostředí Analytical Platform a společného uživatelského účtu."
        },
        {
          "kind": "clause",
          "number": "1.5.",
          "text": "Rozsah dostupných aplikací, produktů a funkcionalit se může lišit zejména podle konkrétního produktu, zvoleného tarifu, technické dostupnosti nebo dalších podmínek uvedených u příslušné funkcionality."
        },
        {
          "kind": "clause",
          "number": "1.6.",
          "text": "Pro konkrétní aplikaci, produkt nebo funkcionalitu mohou být zveřejněny zvláštní obchodní podmínky nebo právní upozornění. Jsou-li takové zvláštní podmínky zveřejněny, použijí se společně s těmito Podmínkami. V případě rozporu mají ve vztahu ke konkrétní aplikaci, produktu nebo funkcionalitě přednost zvláštní podmínky."
        },
        {
          "kind": "clause",
          "number": "1.7.",
          "text": "Uživatelem se pro účely těchto Podmínek rozumí fyzická nebo právnická osoba používající Službu (dále jen „Uživatel“)."
        },
        {
          "kind": "clause",
          "number": "1.8.",
          "text": "Používáním Služby Uživatel potvrzuje, že se s těmito Podmínkami seznámil a souhlasí s nimi."
        }
      ]
    },
    {
      "heading": "2. Charakter Služby",
      "blocks": [
        {
          "kind": "clause",
          "number": "2.1.",
          "text": "Analytical Platform představuje technologickou platformu obsahující analytické aplikace, produkty a nástroje určené zejména pro práci s finančními a investičními daty, analýzu investičních nástrojů a trhů, tvorbu modelů, práci s investičními charakteristikami, analýzu a sestavování portfolií a další související analytické činnosti."
        },
        {
          "kind": "clause",
          "number": "2.2.",
          "text": "Jednotlivé aplikace a funkcionality mohou Uživateli poskytovat zejména data, informace, výpočty, modely, statistiky, analýzy, simulace a další analytické výstupy."
        },
        {
          "kind": "clause",
          "number": "2.3.",
          "text": "Konkrétní funkce dostupné Uživateli závisejí na používané aplikaci, produktu a případně zvoleném tarifu. Ne všechny funkcionality popsané v těchto Podmínkách jsou nutně dostupné v každé aplikaci."
        },
        {
          "kind": "clause",
          "number": "2.4.",
          "text": "Výstupy Služby slouží jako podpora vlastního rozhodování Uživatele."
        },
        {
          "kind": "clause",
          "number": "2.5.",
          "text": "Provozovatel prostřednictvím Služby nerozhoduje za Uživatele, do kterých investičních nástrojů má investovat, které investiční nástroje má koupit, prodat nebo držet ani jaké složení portfolia je pro něj vhodné."
        },
        {
          "kind": "clause",
          "number": "2.6.",
          "text": "Veškerá investiční rozhodnutí činí Uživatel samostatně a na vlastní odpovědnost."
        }
      ]
    },
    {
      "heading": "3. Investiční poradenství a posouzení vhodnosti",
      "blocks": [
        {
          "kind": "clause",
          "number": "3.1.",
          "text": "Provozovatel prostřednictvím Služby neposkytuje investiční poradenství ani individualizovaná investiční doporučení."
        },
        {
          "kind": "clause",
          "number": "3.2.",
          "text": "Provozovatel za účelem posouzení vhodnosti investice, investičního nástroje, portfolia nebo jeho rebalancování nezjišťuje ani neposuzuje informace o Uživateli týkající se zejména:"
        },
        {
          "kind": "bullets",
          "items": [
            "jeho odborných znalostí v oblasti investování;",
            "jeho zkušeností v oblasti investování;",
            "jeho finanční situace a finančního zázemí;",
            "jeho schopnosti nést ztráty;",
            "jeho investičních cílů;",
            "jeho investičního horizontu; ani",
            "jeho tolerance k riziku."
          ]
        },
        {
          "kind": "clause",
          "number": "3.3.",
          "text": "Provozovatel neposuzuje, zda je konkrétní investiční nástroj, portfolio, jeho složení nebo jeho rebalancování vhodné pro konkrétního Uživatele."
        },
        {
          "kind": "clause",
          "number": "3.4.",
          "text": "Parametry a kritéria používaná při sestavení nebo úpravě portfolia volí Uživatel samostatně. Provozovatel tyto parametry ani kritéria neurčuje s ohledem na osobní, finanční nebo jinou individuální situaci Uživatele."
        },
        {
          "kind": "clause",
          "number": "3.5.",
          "text": "Výsledné portfolio nebo jeho úprava vznikají na základě parametrů a kritérií zvolených Uživatelem a předem stanovených pravidel fungování Služby. Provozovatel poskytuje technologický a analytický nástroj umožňující Uživateli realizovat jeho vlastní investiční záměr."
        },
        {
          "kind": "clause",
          "number": "3.6.",
          "text": "Provozovatel neověřuje, zda jsou informace o aktuálním složení portfolia nebo jiné údaje zadané či zpřístupněné Uživatelem pravdivé, správné, úplné nebo aktuální."
        }
      ]
    },
    {
      "heading": "4. Investiční výzkum a investiční doporučení",
      "blocks": [
        {
          "kind": "clause",
          "number": "4.1.",
          "text": "Informace, investiční charakteristiky, skóre, pořadí, modely, výpočty, statistiky, historické analýzy, simulace a další výstupy Služby představují analytické výstupy softwarového nástroje."
        },
        {
          "kind": "clause",
          "number": "4.2.",
          "text": "Tyto výstupy nepředstavují doporučení Uživateli ke koupi, prodeji nebo držení konkrétního investičního nástroje ani návrh investiční strategie přizpůsobené konkrétnímu Uživateli."
        },
        {
          "kind": "clause",
          "number": "4.3.",
          "text": "Provozovatel prostřednictvím Služby neposkytuje investiční výzkum ani investiční doporučení ve smyslu příslušných právních předpisů."
        },
        {
          "kind": "clause",
          "number": "4.4.",
          "text": "Žádný výstup Služby nelze považovat za příslib nebo záruku budoucího vývoje investičního nástroje, portfolia nebo trhu."
        }
      ]
    },
    {
      "heading": "5. Rizika investování a historická výkonnost",
      "blocks": [
        {
          "kind": "clause",
          "number": "5.1.",
          "text": "Investování do investičních nástrojů je spojeno s rizikem. Hodnota investic může růst i klesat a návratnost investice není zaručena."
        },
        {
          "kind": "clause",
          "number": "5.2.",
          "text": "Uživatel může v souvislosti s investováním přijít o část nebo celou investovanou částku."
        },
        {
          "kind": "clause",
          "number": "5.3.",
          "text": "Minulé výnosy ani historická výkonnost nejsou zárukou ani spolehlivým ukazatelem budoucích výnosů."
        },
        {
          "kind": "clause",
          "number": "5.4.",
          "text": "Výsledky backtestů, simulací, optimalizací, modelů a dalších výpočtů založených na historických datech jsou hypotetické. Skutečné budoucí výsledky se mohou od historických nebo modelových výstupů významně lišit."
        },
        {
          "kind": "clause",
          "number": "5.5.",
          "text": "Historické simulace a jiné výpočty nemusí zohledňovat všechny okolnosti reálného obchodování, zejména likviditu, spread, skluz ceny, transakční náklady, poplatky, daně, měnové konverze nebo změny tržních podmínek, není-li u konkrétního výstupu uvedeno jinak."
        }
      ]
    },
    {
      "heading": "6. Data a povaha výstupů Služby",
      "blocks": [
        {
          "kind": "clause",
          "number": "6.1.",
          "text": "Služba pracuje s daty a informacemi pocházejícími z různých externích zdrojů, zejména od poskytovatelů tržních a finančních dat, burz, veřejně dostupných zdrojů a dalších třetích osob (dále jen „Data“)."
        },
        {
          "kind": "clause",
          "number": "6.2.",
          "text": "Provozovatel nemá plnou kontrolu nad vznikem, správností, úplností, přesností, aktuálností ani dostupností Dat a jejich správnost samostatně neověřuje, není-li výslovně uvedeno jinak."
        },
        {
          "kind": "clause",
          "number": "6.3.",
          "text": "Data mohou obsahovat chyby, nepřesnosti, chybějící údaje, duplicity nebo zpoždění. Chyba se může týkat zejména ceny, měny, identifikace investičního nástroje, corporate actions, fundamentálních údajů, historických dat nebo jiných informací."
        },
        {
          "kind": "clause",
          "number": "6.4.",
          "text": "Výstupy Služby, včetně investičních charakteristik, analýz, modelů, návrhů složení portfolia a výsledků rebalancování, jsou automatizovaným výsledkem softwarového systému pracujícího s dostupnými Daty a nastavenými algoritmy."
        },
        {
          "kind": "clause",
          "number": "6.5.",
          "text": "Chybná, neúplná, nepřesná nebo opožděná Data se mohou promítnout do výstupů Služby, včetně analýz, investičních charakteristik, výpočtů, složení portfolia nebo výsledku jeho rebalancování."
        },
        {
          "kind": "clause",
          "number": "6.6.",
          "text": "Provozovatel nezaručuje správnost, úplnost, přesnost, aktuálnost ani nepřetržitou dostupnost Dat."
        },
        {
          "kind": "clause",
          "number": "6.7.",
          "text": "Data, technické zpracování, algoritmy, automatizované výpočty nebo jiné technologické součásti Služby mohou v jednotlivých případech obsahovat chyby, nepřesnosti nebo odchylky."
        },
        {
          "kind": "clause",
          "number": "6.8.",
          "text": "Uživatel bere na vědomí, že výstupy Služby mají analytický a informační charakter a představují pouze jeden z možných podkladů pro jeho vlastní rozhodování."
        },
        {
          "kind": "clause",
          "number": "6.9.",
          "text": "Uživatel je před uskutečněním investičního rozhodnutí nebo transakce povinen zkontrolovat informace, které jsou pro jeho rozhodnutí podstatné."
        }
      ]
    },
    {
      "heading": "7. Funkcionality pro práci s portfoliem a rebalancování",
      "blocks": [
        {
          "kind": "clause",
          "number": "7.1.",
          "text": "Některé aplikace nebo funkcionality Služby mohou Uživateli umožňovat sestavení, analýzu, úpravu nebo rebalancování investičního portfolia podle parametrů a kritérií zvolených Uživatelem."
        },
        {
          "kind": "clause",
          "number": "7.2.",
          "text": "Pokud Služba umožňuje automatický výpočet rebalancace, je výsledná rebalancace generována podle parametrů a kritérií zvolených Uživatelem a předem stanovených pravidel fungování příslušné funkcionality."
        },
        {
          "kind": "clause",
          "number": "7.3.",
          "text": "Provozovatel při takovém rebalancování nemá volnou úvahu o tom, jak má být majetek konkrétního Uživatele investován, a neposuzuje, zda je výsledná rebalancace pro Uživatele vhodná."
        },
        {
          "kind": "clause",
          "number": "7.4.",
          "text": "Výsledná rebalancace představuje výstup analytického nástroje. Je výhradně na Uživateli, zda se rozhodne podle tohoto výstupu své portfolio skutečně změnit."
        },
        {
          "kind": "clause",
          "number": "7.5.",
          "text": "Provozovatel neobhospodařuje majetek Uživatele, jehož součástí je investiční nástroj, na základě volné úvahy v rámci smluvního ujednání."
        },
        {
          "kind": "clause",
          "number": "7.6.",
          "text": "Výsledek rebalancování může být ovlivněn zejména Daty, parametry zvolenými Uživatelem, aktuálním složením portfolia, technickým zpracováním a pravidly fungování příslušné aplikace nebo funkcionality."
        }
      ]
    },
    {
      "heading": "8. Propojení s Brokerem a zprostředkování obchodů",
      "blocks": [
        {
          "kind": "clause",
          "number": "8.1.",
          "text": "Některé aplikace nebo funkcionality Služby mohou umožňovat technické propojení s investičním účtem Uživatele vedeným u podporovaného poskytovatele investičních služeb (dále jen „Broker“)."
        },
        {
          "kind": "clause",
          "number": "8.2.",
          "text": "Pro využití takové funkcionality musí mít Uživatel samostatně založený účet u příslušného Brokera a uzavřený smluvní vztah s Brokerem."
        },
        {
          "kind": "clause",
          "number": "8.3.",
          "text": "Provozovatel není stranou smluvního vztahu mezi Uživatelem a Brokerem a nevystupuje jako zástupce Brokera ani Uživatele."
        },
        {
          "kind": "clause",
          "number": "8.4.",
          "text": "Provozovatel nezprostředkovává obchody s investičními nástroji ani poskytování investičních služeb. Zejména jménem Uživatele ani Brokera nesjednává obchody nebo investiční služby, nepředkládá návrhy na jejich sjednání, neprovádí přípravné práce směřující k jejich sjednání ani neposkytuje doporučení vedoucí k jejich sjednání."
        },
        {
          "kind": "clause",
          "number": "8.5.",
          "text": "Provozovatel není Brokerem odměňován za to, že Uživatel vede nebo rebalancuje své portfolio u příslušného Brokera."
        },
        {
          "kind": "clause",
          "number": "8.6.",
          "text": "Technické propojení může být dostupné pouze u Brokerů, u nichž je takové propojení technicky možné. Okruh podporovaných Brokerů se může v čase měnit."
        }
      ]
    },
    {
      "heading": "9. Přijímání a předávání pokynů",
      "blocks": [
        {
          "kind": "clause",
          "number": "9.1.",
          "text": "Provozovatel nepřijímá od Uživatele pokyny týkající se investičních nástrojů za účelem jejich předávání třetím osobám a neposkytuje službu přijímání a předávání pokynů."
        },
        {
          "kind": "clause",
          "number": "9.2.",
          "text": "Je výhradně na rozhodnutí Uživatele, zda se rozhodne uskutečnit transakce odpovídající výsledku rebalancování."
        },
        {
          "kind": "clause",
          "number": "9.3.",
          "text": "Pokud Služba integruje rozhraní umožňující komunikaci s Brokerem, komunikace týkající se případného investičního pokynu probíhá prostřednictvím technického propojení mezi Uživatelem a Brokerem. Provozovatel nerozhoduje o zadání pokynu ani nemění jeho obsah."
        },
        {
          "kind": "clause",
          "number": "9.4.",
          "text": "Před potvrzením transakce je Uživatel povinen zkontrolovat zejména identifikaci investičního nástroje, směr transakce, množství a další podstatné parametry transakce zobrazené Brokerem."
        },
        {
          "kind": "clause",
          "number": "9.5.",
          "text": "Uživatel je rovněž povinen po uskutečnění transakce ověřit její skutečné provedení a soulad s pokynem, který zadal Brokerovi."
        },
        {
          "kind": "clause",
          "number": "9.6.",
          "text": "Provozovatel negarantuje, že Broker pokyn přijme, provede nebo vypořádá."
        }
      ]
    },
    {
      "heading": "10. Rizika spojená s propojením s Brokerem a provedením transakcí",
      "blocks": [
        {
          "kind": "clause",
          "number": "10.1.",
          "text": "Pokud Uživatel využívá funkcionalitu propojenou s Brokerem, může mezi okamžikem vytvoření analytického výstupu nebo výpočtu rebalancace a skutečným provedením transakce může dojít ke změně ceny, likvidity, dostupnosti nebo jiných vlastností investičního nástroje."
        },
        {
          "kind": "clause",
          "number": "10.2.",
          "text": "Cena skutečně dosažená Brokerem se proto může lišit od ceny zobrazené nebo použité Službou."
        },
        {
          "kind": "clause",
          "number": "10.3.",
          "text": "Pokyn může být proveden pouze částečně, se zpožděním, za jinou cenu nebo nemusí být proveden vůbec."
        },
        {
          "kind": "clause",
          "number": "10.4.",
          "text": "Provozovatel neodpovídá za činnost nebo nečinnost Brokera, zejména za přijetí, odmítnutí, provedení nebo vypořádání pokynu, dosaženou cenu, likviditu, technickou dostupnost služeb Brokera ani správnost údajů vedených Brokerem."
        },
        {
          "kind": "clause",
          "number": "10.5.",
          "text": "Provozovatel nemůže zaručit nepřetržitou dostupnost, správné fungování ani kompatibilitu API nebo jiného technického rozhraní Brokera."
        },
        {
          "kind": "clause",
          "number": "10.6.",
          "text": "Uživatel bere na vědomí, že technické propojení mezi Službou a Brokerem může být ovlivněno okolnostmi mimo kontrolu Provozovatele, včetně výpadků, zpoždění, změn API, omezení na straně Brokera nebo poruch komunikačních sítí."
        }
      ]
    },
    {
      "heading": "11. Technické chyby a dostupnost Služby",
      "blocks": [
        {
          "kind": "clause",
          "number": "11.1.",
          "text": "Provozovatel usiluje o řádné a bezpečné fungování Služby, nemůže však zaručit její nepřetržitou dostupnost ani absolutní bezchybnost."
        },
        {
          "kind": "clause",
          "number": "11.2.",
          "text": "Služba může být dočasně nedostupná zejména z důvodu údržby, aktualizací, technických poruch, výpadků infrastruktury, internetového připojení, API nebo služeb třetích stran."
        },
        {
          "kind": "clause",
          "number": "11.3.",
          "text": "Výstupy Služby mohou být ovlivněny zejména programovou chybou, chybnými nebo neúplnými vstupními Daty, technickou poruchou, chybou výpočtu nebo algoritmu nebo chybnou komunikací s externím systémem."
        },
        {
          "kind": "clause",
          "number": "11.4.",
          "text": "Uživatel nesmí spoléhat na Službu jako na jediný zdroj informací pro své investiční rozhodnutí a před uskutečněním transakce je odpovědný za kontrolu jejích konečných parametrů."
        }
      ]
    },
    {
      "heading": "12. Omezení odpovědnosti",
      "blocks": [
        {
          "kind": "clause",
          "number": "12.1.",
          "text": "Uživatel používá Službu a její analytické výstupy na vlastní odpovědnost."
        },
        {
          "kind": "clause",
          "number": "12.2.",
          "text": "Provozovatel neodpovídá za investiční rozhodnutí Uživatele ani za výsledek investice uskutečněné s využitím informací nebo funkcionalit dostupných prostřednictvím Služby."
        },
        {
          "kind": "clause",
          "number": "12.3.",
          "text": "V maximálním rozsahu dovoleném právními předpisy Provozovatel neodpovídá zejména za újmu vzniklou v důsledku:"
        },
        {
          "kind": "bullets",
          "items": [
            "nesprávných, neúplných, nepřesných, opožděných nebo chybějících Dat;",
            "nesprávných nebo neúplných údajů zadaných nebo zpřístupněných Uživatelem;",
            "výstupů založených na nesprávných nebo neúplných vstupních údajích;",
            "chyby výpočtu, algoritmu, modelu nebo softwaru;",
            "chyby při výpočtu nebo sestavení rebalancace;",
            "výpadku, nedostupnosti nebo nesprávného fungování Služby;",
            "výpadku, chyby nebo změny API Brokera nebo jiné třetí osoby;",
            "rozdílu mezi cenou použitou Službou a cenou skutečného provedení;",
            "neprovedení, opožděného nebo částečného provedení transakce Brokerem;",
            "jednání nebo opomenutí Brokera, poskytovatele Dat nebo jiné třetí osoby; nebo",
            "investičního rozhodnutí Uživatele učiněného s využitím výstupů Služby."
          ]
        },
        {
          "kind": "clause",
          "number": "12.4.",
          "text": "V maximálním rozsahu dovoleném právními předpisy Provozovatel neodpovídá za ušlý zisk, ztrátu investiční příležitosti ani jinou nepřímou nebo následnou újmu."
        },
        {
          "kind": "clause",
          "number": "12.5.",
          "text": "Provozovatel neposkytuje žádnou záruku, že používáním Služby Uživatel dosáhne určitého výnosu, snížení rizika, vyšší výkonnosti portfolia nebo jiného investičního výsledku."
        },
        {
          "kind": "clause",
          "number": "12.6.",
          "text": "Žádné ustanovení těchto Podmínek nevylučuje ani neomezuje odpovědnost Provozovatele v případech, kdy její vyloučení nebo omezení právní předpisy nepřipouštějí."
        }
      ]
    },
    {
      "heading": "13. Registrace a uživatelský účet",
      "blocks": [
        {
          "kind": "clause",
          "number": "13.1.",
          "text": "Některé nebo všechny funkce Služby mohou být dostupné pouze registrovaným Uživatelům."
        },
        {
          "kind": "clause",
          "number": "13.2.",
          "text": "Uživatelský účet může Uživateli umožňovat přístup k více aplikacím, produktům nebo funkcionalitám dostupným prostřednictvím Analytical Platform."
        },
        {
          "kind": "clause",
          "number": "13.3.",
          "text": "Uživatel odpovídá za správnost a aktuálnost údajů poskytnutých při registraci a za zabezpečení svého uživatelského účtu."
        },
        {
          "kind": "clause",
          "number": "13.4.",
          "text": "Uživatel je povinen chránit své přihlašovací údaje a nesmí umožnit neoprávněné osobě používat svůj účet."
        },
        {
          "kind": "clause",
          "number": "13.5.",
          "text": "Uživatel je povinen bez zbytečného odkladu informovat Provozovatele o podezření na neoprávněné použití svého účtu."
        }
      ]
    },
    {
      "heading": "14. Cena a předplatné",
      "blocks": [
        {
          "kind": "clause",
          "number": "14.1.",
          "text": "Některé aplikace, produkty nebo funkcionality Služby mohou být poskytovány bezplatně, jiné mohou být dostupné pouze v rámci placeného předplatného."
        },
        {
          "kind": "clause",
          "number": "14.2.",
          "text": "Cena Služby, rozsah funkcí jednotlivých tarifů a případná omezení jsou uvedeny na příslušných webových stránkách nebo v aplikaci."
        },
        {
          "kind": "clause",
          "number": "14.3.",
          "text": "Před objednáním placené Služby je Uživatel informován o její ceně, délce předplatného a případném automatickém prodlužování."
        },
        {
          "kind": "clause",
          "number": "14.4.",
          "text": "Podrobnosti o způsobu platby, délce předplatného, jeho prodlužování a možnostech ukončení jsou Uživateli sděleny před objednáním placené Služby."
        }
      ]
    },
    {
      "heading": "15. Duševní vlastnictví a používání Služby",
      "blocks": [
        {
          "kind": "clause",
          "number": "15.1.",
          "text": "StockCharacteristics, Analytical Platform, jejich software, algoritmy, modely, databázová struktura, metodiky, texty, grafické zpracování a další obsah jsou chráněny právy duševního vlastnictví Provozovatele nebo třetích osob."
        },
        {
          "kind": "clause",
          "number": "15.2.",
          "text": "Uživatel získává pouze omezené, nevýhradní a nepřenosné oprávnění používat Službu pro účely, ke kterým je určena, a v souladu s těmito Podmínkami."
        },
        {
          "kind": "clause",
          "number": "15.3.",
          "text": "Bez předchozího souhlasu Provozovatele není dovoleno zejména systematicky kopírovat, stahovat, redistribuovat nebo komerčně využívat obsah či data Služby, provádět scraping, obcházet technická omezení nebo se pokoušet získat zdrojový kód Služby."
        },
        {
          "kind": "clause",
          "number": "15.4.",
          "text": "Data poskytovaná třetími osobami mohou podléhat samostatným licenčním omezením příslušných poskytovatelů."
        }
      ]
    },
    {
      "heading": "16. Změny a ukončení Služby",
      "blocks": [
        {
          "kind": "clause",
          "number": "16.1.",
          "text": "Provozovatel je oprávněn Analytical Platform a jednotlivé aplikace, produkty a funkcionality průběžně aktualizovat, měnit a rozvíjet."
        },
        {
          "kind": "clause",
          "number": "16.2.",
          "text": "Dostupnost některých funkcí může být změněna, omezena nebo ukončena zejména v případě změny spolupráce s poskytovatelem Dat, Brokerem nebo jiným dodavatelem technologie."
        },
        {
          "kind": "clause",
          "number": "16.3.",
          "text": "Provozovatel je oprávněn omezit nebo ukončit přístup Uživatele, který Službu používá v rozporu s těmito Podmínkami nebo právními předpisy."
        }
      ]
    },
    {
      "heading": "17. Ochrana osobních údajů",
      "blocks": [
        {
          "kind": "clause",
          "number": "17.1.",
          "text": "Zpracování osobních údajů Uživatele se řídí samostatnými Zásadami ochrany osobních údajů zveřejněnými Provozovatelem."
        }
      ]
    },
    {
      "heading": "18. Rozhodné právo a spotřebitelé",
      "blocks": [
        {
          "kind": "clause",
          "number": "18.1.",
          "text": "Tyto Podmínky a právní vztahy vznikající v souvislosti s používáním Služby se řídí právním řádem České republiky."
        },
        {
          "kind": "clause",
          "number": "18.2.",
          "text": "Je-li Uživatel spotřebitelem, nejsou těmito Podmínkami dotčena jeho práva vyplývající z právních předpisů na ochranu spotřebitele, která nelze smluvně vyloučit nebo omezit."
        },
        {
          "kind": "clause",
          "number": "18.3.",
          "text": "Je-li Uživatel spotřebitelem, budou mu v souvislosti s uzavřením smlouvy poskytnuty informace a práva vyžadovaná příslušnými právními předpisy pro poskytování digitálního obsahu nebo digitálních služeb."
        }
      ]
    },
    {
      "heading": "19. Závěrečná ustanovení",
      "blocks": [
        {
          "kind": "clause",
          "number": "19.1.",
          "text": "Provozovatel může tyto Podmínky v přiměřeném rozsahu změnit zejména v návaznosti na změnu Služby, právních předpisů, používaných technologií nebo obchodního modelu. O podstatných změnách bude Uživatel informován přiměřeným způsobem."
        },
        {
          "kind": "clause",
          "number": "19.2.",
          "text": "Aktuální znění Podmínek je dostupné na webových stránkách Provozovatele."
        },
        {
          "kind": "clause",
          "number": "19.3.",
          "text": "Pokud je některé ustanovení těchto Podmínek neplatné, neúčinné nebo nevymahatelné, nemá tato skutečnost vliv na platnost a účinnost ostatních ustanovení."
        },
        {
          "kind": "clause",
          "number": "19.4.",
          "text": "Pokud jsou pro konkrétní aplikaci, produkt nebo funkcionalitu zveřejněny zvláštní podmínky, použijí se společně s těmito Podmínkami a v případě rozporu mají ve vztahu k dané aplikaci, produktu nebo funkcionalitě přednost."
        },
        {
          "kind": "note",
          "lines": [
            "CCFR",
            "E-mail: app@analyticalplatform.com",
            "Telefon: +420 530 338 808"
          ]
        }
      ]
    }
  ]
};

export default termsCs;
